import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService, LazyLoadEvent } from 'primeng/api';
import { VendorService } from '../vendor.service';
import { Vendor } from '../vendor';
import { getDomainOptions } from '@app/_constants/task-code-registry';

@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.component.html',
  styleUrls: ['./vendor-list.component.scss'],
  providers: [MessageService],
  standalone: false
})
export class VendorListComponent implements OnInit {

  vendors: Vendor[] = [];
  loading = true;
  recordTotal = 0;
  first = 0;
  rows = 50;
  multiSortMeta = [];

  regionOptions = getDomainOptions('REGION');
  vendorTypeOptions = getDomainOptions('VENDOR_TYPE');

  activeFilter: number | null = null;
  regionFilter: number | null = null;
  vendorTypeFilter: number | null = null;

  activeOptions = [
    { label: 'All', value: null },
    { label: 'Active', value: 1 },
    { label: 'Inactive', value: 0 }
  ];

  columns = [
    { field: 'name', header: 'Name' },
    { field: 'region', header: 'Region' },
    { field: 'vendorType', header: 'Vendor Type' },
    { field: 'paymentMethod', header: 'Payment Method' },
    { field: 'paymentTermsDays', header: 'Net N Days' },
    { field: 'isActive', header: 'Active' },
    { field: 'createDate', header: 'Created Date' }
  ];

  constructor(
    private vendorService: VendorService,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadVendors();
  }

  loadVendors(): void {
    this.loading = true;
    const filters: any = {};
    if (this.regionFilter != null) { filters.region = { value: this.regionFilter, matchMode: 'equals' }; }
    if (this.vendorTypeFilter != null) { filters.vendorType = { value: this.vendorTypeFilter, matchMode: 'equals' }; }
    if (this.activeFilter != null) { filters.isActive = { value: this.activeFilter, matchMode: 'equals' }; }

    this.vendorService.findByFilter(
      this.first / this.rows,
      this.rows,
      'name',
      1,
      null,
      null,
      filters
    ).subscribe({
      next: (res) => {
        if (res && res.data) {
          this.vendors = Array.isArray(res.data) ? res.data : (res.data.vendors || res.data.content || []);
          this.recordTotal = res.page ? (res.page.recordTotal || res.page.totalElements || this.vendors.length) : this.vendors.length;
        } else {
          this.vendors = [];
        }
        this.loading = false;
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load vendors' });
        this.loading = false;
      }
    });
  }

  loadLazy(event: LazyLoadEvent): void {
    this.first = event.first || 0;
    this.rows = event.rows || 50;
    this.loadVendors();
  }

  onNewVendor(): void {
    this.router.navigate(['/vendors', 'new']);
  }

  onRowSelect(event: any): void {
    this.router.navigate(['/vendors', event.data.vendorId]);
  }

  onEditVendor(vendor: Vendor): void {
    this.router.navigate(['/vendors', vendor.vendorId]);
  }

  applyFilters(): void {
    this.first = 0;
    this.loadVendors();
  }

  getRegionLabel(value: number): string {
    const opt = this.regionOptions.find(o => o.value === value);
    return opt ? opt.label : String(value);
  }

  getVendorTypeLabel(value: number): string {
    const opt = this.vendorTypeOptions.find(o => o.value === value);
    return opt ? opt.label : String(value);
  }

  getPaymentLabel(value: number): string {
    const opts = getDomainOptions('PAYMENT');
    const opt = opts.find(o => o.value === value);
    return opt ? opt.label : String(value);
  }
}
